<form class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate" [formGroup]="form"
  id="kt_login_password_reset_form">
  <div class="text-center mb-10">
    <h1 class="text-dark mb-3">Resetar Senha</h1>
    <div class="text-gray-500 fs-6">
      Já alterou sua senha?

      <a [routerLink]="['/' + companyKey + '/auth/login']" class="link-primary fw-bold">
        Efetuar Login
      </a>
    </div>
  </div>

  <div class="fv-row mb-10">
    <ng-template #popContent>
      Entre 8 e 50 carateres. <br />
      Mínimo de 1 número. <br />
      Mínimo de 1 caractere maiúsculo.
      <br />
      Mínimo de 1 caractere especial.
      <br />
    </ng-template>

    <label class="form-label text-gray-900 fs-6">Nova Senha</label>
    <input class="form-control form-control-lg form-control-solid" type="password" placeholder="Nova Senha"
      formControlName="newPassword" autocomplete="off" [ngClass]="{
        'is-invalid': form.controls['newPassword'].invalid,
        'is-valid': form.controls['newPassword'].valid
      }" triggers="focus" placement="top"
        popoverTitle="Requisitos da Senha" [ngbPopover]="popContent" #p1="ngbPopover"/>

    <app-field-control-error [control]="form.get('newPassword')" label="Nova Senha"></app-field-control-error>
  </div>

  <div class="fv-row mb-10">
    <label class="form-label text-gray-900 fs-6">Confirmação da Senha </label>
    <input class="form-control form-control-lg form-control-solid" type="password" placeholder="Confirmação da Senha"
      formControlName="retypedPassword" autocomplete="off" [ngClass]="{
        'is-invalid': form.controls['retypedPassword'].invalid,
        'is-valid': form.controls['retypedPassword'].valid
      }" />

    <app-field-control-error [control]="form.get('retypedPassword')"
      label="Confirmação da Senha"></app-field-control-error>
  </div>
  <div class="d-flex flex-wrap justify-content-center pb-lg-0">
    <button type="submit" id="kt_password_reset_submit" class="btn btn-lg btn-primary me-4" (click)="submit()"
      [disabled]="loading$ | async">
      <ng-container *ngIf="loading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Aguarde...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(loading$ | async) === false">
        <span class="indicator-label">Enviar</span>
      </ng-container>
    </button>
    <a [routerLink]="['/auth/login']" id="kt_login_password_reset_form_cancel_button" class="btn btn-lg btn-light">
      Cancelar
    </a>
  </div>
</form>
